import getPatientAddress from 'utils/print/getPatientAddress';
import getPatientCity from 'utils/print/getPatientCity';
import getPatientState from 'utils/print/getPatientState';
import getPatientZip from 'utils/print/getPatientZip';

const getPatientFullAddress = ({ value, ...otherProps }) => {
  if (value !== null && value !== undefined) {
    return value;
  }
  const address = getPatientAddress(otherProps);
  const city = getPatientCity(otherProps);
  const state = getPatientState(otherProps);
  const zip = getPatientZip(otherProps);

  if (address && city && zip) {
    return `${address}, ${city}, ${state || ''} ${zip}`;
  }

  return null;
};

export default getPatientFullAddress;



// WEBPACK FOOTER //
// ./src/utils/print/getPatientFullAddress.js